/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Realtime Schema Projection
 * Frontend-only aliases for realtime payload validation.
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const ServiceFunctionId = zod.uuid().describe("Service Function identity.");

export type ServiceFunctionId = zod.input<typeof ServiceFunctionId>;
export type ServiceFunctionIdOutput = zod.output<typeof ServiceFunctionId>;
